"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.makeInitialContext = exports.withStoreContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _shopifyBuy = _interopRequireDefault(require("shopify-buy"));

var initialContext = {
  client: null
};

var makeInitialContext = function makeInitialContext(config) {
  return (0, _extends2.default)({}, initialContext, {
    client: _shopifyBuy.default.buildClient(config)
  });
};

exports.makeInitialContext = makeInitialContext;

var StoreContext = /*#__PURE__*/_react.default.createContext(initialContext);

exports.default = StoreContext;

var withStoreContext = function withStoreContext(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(StoreContext.Consumer, null, function (context) {
      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
        storeContext: context
      }));
    });
  };
};

exports.withStoreContext = withStoreContext;